import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { API_BASE } from '../utils/api';

const formatDateTime = (value) => {
  if (!value) return 'N/A';

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return value;
  }

  return parsedDate.toLocaleString();
};

function BoxDetail({ boxId, refreshKey = 0 }) {
  const [box, setBox] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBox = async () => {
      if (!boxId) return;
      
      setLoading(true);
      setError('');
      
      try {
        const url = `${API_BASE}/box-status-data/${boxId}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || `Failed to fetch the box (Status: ${response.status})`);
        }

        const data = await response.json();
        setBox(data);
      } catch (err) {
        setError(err.message || 'An error occurred while fetching the box');
        console.error(`Fetch box error for URL [${API_BASE}/box-status-data/${boxId}]:`, err);
      } finally {
        setLoading(false);
      }
    };

    fetchBox();
  }, [boxId, refreshKey]);

  if (loading) return <div className="text-center mt-3"><div className="spinner-border text-primary" role="status" /></div>;
  if (error) return <div className="alert alert-danger mt-3">{error}</div>;
  if (!box) return <div className="text-muted mt-3">No box selected.</div>;

  return (
    <div className="card mt-2 box-detail-card">
      <div className="card-header bg-dark text-white py-0">
        <div className="fw-bold py-1">Box {box.DHTBOX_id}</div>
      </div>
      <div className="card-body p-0">
        <ul className="list-group list-group-flush small">
          <li className="list-group-item py-0"><strong>L:</strong> {box.DHTBOX_length_mm} <strong>W:</strong> {box.DHTBOX_width_mm} <strong>H:</strong> {box.DHTBOX_height_mm}</li>
          <li className="list-group-item py-0"><strong>Hotel:</strong> {box.DHTHOT_id || 'N/A'} <strong>QR:</strong> {box.DHTBOX_qr_code}</li>
          <li className="list-group-item py-0"><strong>Status:</strong> {box.statusName || box.DHTBST_id || 'Unknown'}</li>
          <li className="list-group-item py-0"><strong>Status Updated:</strong> {formatDateTime(box.DHTBXS_status_DateTime || box.boxStatusEntryDate)}</li>
          <li className="list-group-item py-0"><strong>Usage:</strong> {formatDateTime(box.DHTBXU_start_DateTime)} - {formatDateTime(box.DHTBXU_end_DateTime)}</li>
          {box.DHTBOX_entry_Date && (
            <li className="list-group-item py-0">
              <strong>Entry:</strong> {formatDateTime(box.DHTBOX_entry_Date)}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default BoxDetail;
